
<template>
  <el-dialog v-if="reportListVisible" :visible.sync="reportListVisible" :title="'群体报告下载'" width="1000px">
    <SearchBox1 ref="SearchBox1" :params="searchParams" />
    <SearchBox2 ref="SearchBox2" class="mt20" :params="searchParams" />
    <SearchBox3 ref="SearchBox3" class="mt20" :params="searchParams" />
    <template v-slot:footer>
      <el-button size="small" type="primary" class="down-btn" @click="download">下载</el-button>
    </template>
  </el-dialog>
</template>
<script>
import SearchBox1 from './SearchBox1.vue'
import SearchBox2 from './SearchBox2.vue'
import SearchBox3 from './SearchBox3.vue'

export default {
  components: {
    SearchBox1,
    SearchBox2,
    SearchBox3
  },
  props: {
    searchParams: {}
  },
  data() {
    return {
      reportListVisible: false

    }
  },
  created() {

  },
  methods: {
    open() {
      this.reportListVisible = true
    },
    download() {
      // const arr = []

      // if (this.$refs.SearchBox1.checkAll) {
      //   this.$refs.SearchBox1.download()
      //   this.$nextTick(() => {
      //     const ele11 = document.getElementById('Page1Pdf1')
      //     const ele12 = document.getElementById('Page1Pdf2')
      //     const ele13 = document.getElementById('Page1Pdf3')
      //     const ele14 = document.getElementById('Page1Pdf4')
      //     arr.push(ele11)
      //     arr.push(ele12)
      //     arr.push(ele13)
      //     arr.push(ele14)
      //   })
      // }
      // if (this.$refs.SearchBox3.checkAll) {
      //   this.$refs.SearchBox3.download()
      //   this.$nextTick(() => {
      //     const ele31 = document.getElementById('Page3Pdf1')
      //     const ele32 = document.getElementById('Page3Pdf2')
      //     const ele33 = document.getElementById('Page3Pdf3')
      //     arr.push(ele31)
      //     arr.push(ele32)
      //     arr.push(ele33)
      //   })
      // }
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     if (arr.length !== 0) {
      //       savePdfImgs(arr, '群体分析报告', () => {
      //       })
      //     }
      //   }, 500)
      // })

      for (let i = 0; i < 3; i++) {
        if (this.$refs[`SearchBox${i + 1}`].checkAll) {
          localStorage.setItem(`page${i + 1}Show`, 'true')
          localStorage.setItem(`searchParams${i + 1}`, JSON.stringify(this.$refs[`SearchBox${i + 1}`].searchParams))
        } else {
          localStorage.setItem(`page${i + 1}Show`, 'false')
        }
      }
      const { href } = this.$router.resolve({ path: '/pdfPrev' })
      window.open(href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.down-btn{
  width: 120px;
}
</style>
